
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/muse/certify",
      function () {
        return require("private-next-pages/muse/certify/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/muse/certify"])
      });
    }
  